(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Modal-t-faq"] && !Shopify.designMode) return;
  try {
    

  $(document).ready(function() {
  //toggle the component with class accordion_body
  $(".accordion_head").click(function() {
    if ($('.accordion_body').is(':visible')) {
      $(".accordion_body").slideUp(300);
      $(".plusminus").text('+');
    }
    if ($(this).next(".accordion_body").is(':visible')) {
      $(this).next(".accordion_body").slideUp(300);
      $(this).children(".plusminus").text('+');
    } else {
      $(this).next(".accordion_body").slideDown(300);
      $(this).children(".plusminus").text('-');
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["incredible-shaves"] && !Shopify.designMode) return;
  try {
    
     gsap.registerPlugin(ScrollTrigger);

  function setScrollText() {
    gsap.to('#heading1', {
      scrollTrigger: {
        trigger: '#heading1',
        start: '-=1000s', // Adjust the start trigger position
        end: '+=1000s',
        toggleActions: 'play reverse play reverse',
      },
      opacity: 1,
    });

    gsap.to('#heading2', {
      scrollTrigger: {
        trigger: '#heading2',
        start: '+=0s', // Adjust the start trigger position
        end: '+=1000s',
        toggleActions: 'play reverse play reverse',
      },
      opacity: 1,
    });

    gsap.to('#heading3', {
      scrollTrigger: {
        trigger: '#heading3',
        start: '+=1000s', // Adjust the start trigger position
        end: '+=1000s',
        toggleActions: 'play reverse play reverse',
      },
      opacity: 1,
    });
  }
  
  gsap.to('.head', {
    scrollTrigger: {
      trigger: '.head',
      start: 'top top', // Adjust the start trigger position
      end: '+=1500s',
      pin: true,
      pinSpacing: true,
    },
  });

  setScrollText();
  setScrollImages();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["incredible-shaves5"] && !Shopify.designMode) return;
  try {
    
     gsap.registerPlugin(ScrollTrigger);

  function setScrollText() {
    gsap.to('#heading1', {
      scrollTrigger: {
        trigger: '#heading1',
        start: '-=1000s', // Adjust the start trigger position
        end: '+=1000s',
        toggleActions: 'play reverse play reverse',
      },
      opacity: 1,
    });
    
    gsap.to('#heading2', {
      scrollTrigger: {
        trigger: '#heading1',
        start: '-=0s', // Adjust the start trigger position
        end: '+=1000s',
        toggleActions: 'play reverse play reverse',
      },
      opacity: 1,
    });

    gsap.to('#heading3', {
      scrollTrigger: {
        trigger: '#heading3',
        start: '+=1000s', // Adjust the start trigger position
        end: '+=1000s',
        toggleActions: 'play reverse play reverse',
      },
      opacity: 1,
    });

    gsap.to('#heading4', {
      scrollTrigger: {
        trigger: '#heading4',
        start: '+=2000s', // Adjust the start trigger position
        end: '+=1000s',
        toggleActions: 'play reverse play reverse',
      },
      opacity: 1,
    });

    gsap.to('#heading5', {
      scrollTrigger: {
        trigger: '#heading5',
        start: '+=3000s', // Adjust the start trigger position
        end: '+=1000s',
        toggleActions: 'play reverse play reverse',
      },
      opacity: 1,
    });
  }
  
  gsap.to('.head', {
    scrollTrigger: {
      trigger: '.head',
      start: 'top top', // Adjust the start trigger position
      end: '+=3500s',
      pin: true,
      pinSpacing: true,
    },
  });

  setScrollText();
  setScrollImages();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["listing-product"] && !Shopify.designMode) return;
  try {
    
  var sections = $('.product-box')
  , nav = $('.nav')
  , nav_height = nav.outerHeight();

$(window).on('scroll', function () {
  var cur_pos = $(this).scrollTop();
  
  // sections.each(function() {
  //   var top = $(this).offset().top - nav_height,
  //       bottom = top + $(this).outerHeight();
  //   if (cur_pos >= top && cur_pos <= bottom) {
  //     nav.find('.nav-link').removeClass('active');
  //     sections.removeClass('active');
  //     $(this).addClass('active'); nav.find('a[href="#'+$(this).attr('id')+'"]').addClass('active');
  //   }
  // });
});
   $(document).ready(function () {
            $('.nav-link').click(function () {
                // Remove active class from all nav-items
                $('.nav-link').removeClass('active');

                // Add active class to the clicked item
                $(this).addClass('active');
            });
        });
  
   $(document).ready(function () {
            var element = $('.sticky');
            var initialTop = element.offset().top;

            $(window).scroll(function () {
                var scrollPosition = $(window).scrollTop();

                if (scrollPosition >= initialTop) {

                    element.css({
                        position: 'sticky',
                        top: 0,
                        left: 0,
                        width: '100%',
                        backgroundColor: '#fff',
                        padding: '20px',
                        boxShadow: '0 0 5px 0 rgba(0,0,0,0.2)',
                        zIndex: '1',
                    });
                } else {
                    element.css({
                        position: 'static',
                        boxShadow: 'none',
                    });
                }
            });
        });

  jQuery('.page-link').click(function (e) {
            e.preventDefault();
            var menu_height = jQuery('header').outerHeight();
            var href = $(this).attr('href');
            setTimeout(function () {
                $('html,body').animate({ scrollTop: $(href).offset().top - menu_height });
            }, 500);
        });

   $('.tabs-slide').slick({
    margin:30,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
       
          {
        breakpoint: 1400,
        settings: {
          arrows: true,
          slidesToShow: 4
        }
      },
        {
        breakpoint: 991,
        settings: {
          arrows: true,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          slidesToShow: 2
        }
      },
        {
        breakpoint: 575,
        settings: {
          arrows: true,
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: true,
          slidesToShow: 1
        }
      }
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-6s-landing"] && !Shopify.designMode) return;
  try {
    
    $(document).ready(function() {
  //toggle the component with class accordion_body
  $(".accordion_head").click(function() {
    if ($('.accordion_body').is(':visible')) {
      $(".accordion_body").slideUp(300);
      $(".plusminus").text('+');
    }
    if ($(this).next(".accordion_body").is(':visible')) {
      $(this).next(".accordion_body").slideUp(300);
      $(this).children(".plusminus").text('+');
    } else {
      $(this).next(".accordion_body").slideDown(300);
      $(this).children(".plusminus").text('-');
    }
  });
});
     
$(document).ready(function() {

var MenuTitres = $('a[href*=#]');
var AnchorOffset = -200;
  
// ANCHORS MENU OFFSET & SCROLL
function filterPath(string) {
  return string
    .replace(/^\//,'')
    .replace(/(index|default).[a-zA-Z]{3,4}$/,'')
    .replace(/\/$/,'');
  }
  
var locationPath = filterPath(location.pathname);
var scrollElem = scrollableElement('html', 'body');

MenuTitres.each(function() {
    var thisPath = filterPath(this.pathname) || locationPath;
    if (  locationPath == thisPath
    && (location.hostname == this.hostname || !this.hostname)
    && this.hash.replace(/#/,'') ) {
      var $target = $(this.hash), target = this.hash;
      if (target) {
        var targetOffset = $target.offset().top-AnchorOffset;
        $(this).click(function(event) {
          event.preventDefault();
          $(scrollElem).animate({scrollTop: targetOffset}, 8000, function() {
            //location.hash = target;
          });
        });
      }
    }
});

  // use the first element that is "scrollable"
function scrollableElement(els) {
    for (var i = 0, argLength = arguments.length; i <argLength; i++) {
      var el = arguments[i],
          $scrollElement = $(el);
      if ($scrollElement.scrollTop()> 0) {
        return el;
      } else {
        $scrollElement.scrollTop(1);
        var isScrollable = $scrollElement.scrollTop()> 0;
        $scrollElement.scrollTop(0);
        if (isScrollable) {
          return el;
        }
      }
    }
    return [];
}

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-announcement"] && !Shopify.designMode) return;
  try {
    
     $(document).ready(function () {
            var element = $('.sticky');
            var initialTop = element.offset().top;

            $(window).scroll(function () {
                var scrollPosition = $(window).scrollTop();

                if (scrollPosition >= initialTop) {

                    element.css({
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        width: '100%',
                        backgroundColor: '#041D35',
                        padding: '10px 0px',
                        zIndex: '999999',
                       visibility: 'visible',
                    });
                } else {
                    element.css({
                        position: 'fixed',
                        boxShadow: 'none',
                       visibility: 'hidden',
                    
                    });
                }
            });
        });
    jQuery('.page-link').click(function (e) {
            e.preventDefault();
            var menu_height = jQuery('header').outerHeight();
            var href = $(this).attr('href');
            setTimeout(function () {
                $('html,body').animate({ scrollTop: $(href).offset().top - menu_height });
            }, 500);
        });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rockwell-2c-faq"] && !Shopify.designMode) return;
  try {
    

  $(document).ready(function() {
  //toggle the component with class accordion_body
  $(".accordion_head").click(function() {
    if ($('.accordion_body').is(':visible')) {
      $(".accordion_body").slideUp(300);
      $(".plusminus").text('+');
    }
    if ($(this).next(".accordion_body").is(':visible')) {
      $(this).next(".accordion_body").slideUp(300);
      $(this).children(".plusminus").text('+');
    } else {
      $(this).next(".accordion_body").slideDown(300);
      $(this).children(".plusminus").text('-');
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
